import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type managedFarmStateType = {
  address: string | null;
  coordinates: { x: number; y: number };
  pnu: string;
  landInfo: {
    landArea: number;
    areaInPyeong: number;
    pnu: string;
    addressTrailingParts: string;
  } | null;
  mapImage: string | null;
  fieldOwnerName: string;
  fieldOwnerPhoneNumber: string;
  taskType: string;
  taskTypeEtc: string;
  equipment: string;
  equipmentEtc: string;
  cropType: string;
  cropTypeEtc: string;
  startDate: Date | undefined;
  endDate: Date | undefined;
};

const initialState: managedFarmStateType = {
  // TODO : 농사 반장 폼 페이지 접근 불가 케이스 구현 https://gint-team.atlassian.net/browse/PVM-3499
  coordinates: { x: 0, y: 0 },
  pnu: '',
  address: null,
  landInfo: null,
  mapImage: null,
  fieldOwnerName: '',
  fieldOwnerPhoneNumber: '',
  taskType: '',
  taskTypeEtc: '',
  equipment: '',
  equipmentEtc: '',
  cropType: '',
  cropTypeEtc: '',
  startDate: undefined,
  endDate: undefined,
};

export const managedFarmSlice = createSlice({
  name: 'managedFarm',
  initialState,
  reducers: {
    resetState: (state) => {
      state.address = null;
      state.coordinates = { x: 0, y: 0 };
      state.pnu = '';
      state.landInfo = null;
      state.mapImage = null;
      state.fieldOwnerName = '';
      state.fieldOwnerPhoneNumber = '';
      state.taskType = '';
      state.taskTypeEtc = '';
      state.equipment = '';
      state.equipmentEtc = '';
      state.cropType = '';
      state.cropTypeEtc = '';
      state.startDate = undefined;
      state.endDate = undefined;
    },

    setAddress: (state, action: PayloadAction<string>) => {
      state.address = action.payload;
    },

    setLandInfo: (
      state,
      action: PayloadAction<{
        landArea: number;
        areaInPyeong: number;
        pnu: string;
        addressTrailingParts: string;
      }>,
    ) => {
      state.landInfo = action.payload;
    },

    setCoordinates: (state, action: PayloadAction<{ x: number; y: number }>) => {
      state.coordinates = action.payload;
    },

    setPnu: (state, action: PayloadAction<string>) => {
      state.pnu = action.payload;
    },

    setMapImage: (state, action: PayloadAction<string>) => {
      state.mapImage = action.payload;
    },

    changeFieldOwnerName: (state, action: PayloadAction<string>) => {
      state.fieldOwnerName = action.payload;
    },

    changeFieldOwnerPhoneNumber: (state, action: PayloadAction<string>) => {
      state.fieldOwnerPhoneNumber = action.payload;
    },

    changeTaskType: (state, action: PayloadAction<string>) => {
      state.taskType = action.payload;
    },

    changeTaskTypeEtc: (state, action: PayloadAction<string>) => {
      state.taskTypeEtc = action.payload;
    },

    changeEquipment: (state, action: PayloadAction<string>) => {
      state.equipment = action.payload;
    },

    changeEquipmentEtc: (state, action: PayloadAction<string>) => {
      state.equipmentEtc = action.payload;
    },

    changeCropType: (state, action: PayloadAction<string>) => {
      state.cropType = action.payload;
    },

    changeCropTypeEtc: (state, action: PayloadAction<string>) => {
      state.cropTypeEtc = action.payload;
    },

    changeStartDate: (state, action: PayloadAction<Date>) => {
      state.startDate = action.payload;
    },

    changeEndDate: (state, action: PayloadAction<Date>) => {
      state.endDate = action.payload;
    },
  },
});
